<script lang="ts">
    import {getPageContext} from 'shared/layouts';
    import {ProjectFinancialOverview} from 'src/features/erp-sutor/features/project-financial-overview';
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from 'src/features/record/kp-document-detail-page/types';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const projectRecord = pageContext.staticData.model.record;
</script>

<KpHeading type="h2">Hospodaření zakázky</KpHeading>
<ProjectFinancialOverview {projectRecord}/>